<script>
import OrderHistory from './OrderHistory'
import BasicInfo from './BasicInfo'
import FavoriteItems from './FavoriteItems'
import Order from '../../models/Order'

export default {
    name: 'mypage',

    data() {
        return {
            isActive: this.getHash() || 'order_history',
            orderHistories: [],
        }
    },

    props: {
        data: {},
    },

    created() {
        const _orders = eval(this.data).orders
        this.orderHistories = _orders.data.map((x) => {
            return new Order(x)
        })
    },

    methods: {
        change(name) {
            this.isActive = name
        },
        getHash() {
            const hash = location.hash.split('?')[0].slice(1)
            const query = window.location.search.slice(1)
            if (query && !hash) {
                return 'order_history'
            }
            return hash ? hash : ''
        },
    },

    components: {
        OrderHistory,
        BasicInfo,
        FavoriteItems,
    },
}
</script>

<style lang="scss" scoped>
#product_history,
#favorite {
    .product-image-link.category-img {
        margin-bottom: 10px;
        img {
            height: 150px;
        }
    }

    .product {
        &-item {
            padding: 0 15px;
        }
        &Body {
            padding: 0 15px 15px 15px;
            .category {
                white-space: pre-line;
                border-bottom: 1px dotted;
                padding-bottom: 5px;
                margin-bottom: 5px;
                line-height: 15px;
                color: #333333;
            }
            .detail {
                color: #333;
                font-size: 13px;
                background: #d6d7d7;
                padding: 0 12px;
                border-radius: 6px;
                margin-left: auto;
                &:hover {
                    opacity: 0.7;
                }
            }
            .product-title {
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        &:hover {
            opacity: 0.8;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/mypage/Mypage.vue